import React from 'react'
import cheeto from '../assets/CheetoImage.png'
import mascort from '../assets/mascort2.gif'
const Cartoon = () => {
  return (
    <div>
      <img 
        src={mascort} 
        className="w-[130px] fixed bottom-5 right-5 cursor-pointer hover:scale-110 transition-transform" 
        alt="Cheeto Icon"
      />
    </div>
  )
}

export default Cartoon
